declare let require: any;

import * as env from '../assets/js/env5.ef5f9c52b00e3f87c959.js';

export const environment = {
  app_version: env.app_version,
  base_url: env.base_url,
  benefits_url: env.benefits_url,
  cdn_url: env.cdn_url,
  conta_unico_client_id: env.conta_unico_client_id,
  conta_unico_url: env.conta_unico_url,
  current_environment: env.current_environment,
  grpc_url: env.grpc_url,
  identity_url: env.identity_url,
  iframe_resizer_key: env.iframe_resizer_key,
  launchDarklyClientId: env.launchDarklyClientId,
  maps_key: env.maps_key,
  mixpanelToken: env.mixpanelToken,
  preview: env.preview,
  productId: env.productId,
  production: true,
  redirect_uri: env.redirect_uri,
  report_versions: env.report_versions,
  segmentApiKey: env.segmentApiKey,
  sentry_dsn: env.sentry_dsn,
  sentry_enabled: env.sentry_enabled,
  sentry_ignore_errors: env.sentry_ignore_errors,
  sentry_ignore_status_code_errors: env.sentry_ignore_status_code_errors,
  sign_callback_url: env.sign_callback_url,
  sign_envelopes_management_url: env.sign_envelopes_management_url,
  sign_id: env.sign_id,
  sign_people_product_id: env.sign_people_product_id,
  sign_url: env.sign_url,
  snippet_zendesk: env.snippet_zendesk,
  url: env.url,
  url_benefit: env.url_benefit,
  url_grpc: env.url_grpc,
  url_routing_api: env.url_routing_api
};
